export default [
  { id: 1, key: '0', value: '', label: '∅' },
  { id: 2, key: 'b', value: 'b', label: 'b' },
  { id: 3, key: 'c', value: 'c', label: 'c' },
  { id: 4, key: 'hj', value: 'ç', label: 'ç' },
  { id: 5, key: 'd', value: 'd', label: 'd' },
  { id: 6, key: 'dh', value: 'ð', label: 'ð' },
  { id: 7, key: 'f', value: 'f', label: 'f' },
  { id: 8, key: 'g', value: 'g', label: 'g' },
  { id: 9, key: 'h', value: 'h', label: 'h' },
  { id: 10, key: 'j', value: 'j', label: 'j' },
  { id: 11, key: 'gj', value: 'ɟ', label: 'ɟ' },
  { id: 12, key: 'k', value: 'k', label: 'k' },
  { id: 13, key: 'm', value: 'm', label: 'm' },
  { id: 14, key: 'n', value: 'n', label: 'n' },
  { id: 15, key: 'nj', value: 'ɲ', label: 'ɲ' },
  { id: 16, key: 'p', value: 'p', label: 'p' },
  { id: 17, key: 'r', value: 'r', label: 'r' },
  { id: 18, key: 's', value: 's', label: 's' },
  { id: 19, key: 'sh', value: 'ʃ', label: 'ʃ' },
  { id: 20, key: 't', value: 't', label: 't' },
  { id: 21, key: 'ts', value: 't͡s', label: 't͡s' },
  { id: 22, key: 'tsh', value: 't͡ʃ', label: 't͡ʃ' },
  { id: 23, key: 'v', value: 'v', label: 'v' },
  { id: 24, key: 'w', value: 'w', label: 'w' },
  { id: 25, key: 'z', value: 'z', label: 'z' },
  { id: 26, key: 'zh', value: 'ʒ', label: 'ʒ' },
  { id: 27, key: 'th', value: 'θ', label: 'θ' },
  { id: 28, key: 'bj', value: 'bj', label: 'bj' },
  { id: 29, key: 'br', value: 'br', label: 'br' },
  { id: 30, key: 'bw', value: 'bw', label: 'bw' },
  { id: 31, key: 'cv', value: 'cv', label: 'cv' },
  { id: 32, key: 'dj', value: 'dj', label: 'dj' },
  { id: 33, key: 'dr', value: 'dr', label: 'dr' },
  { id: 34, key: 'dv', value: 'dv', label: 'dv' },
  { id: 35, key: 'dw', value: 'dw', label: 'dw' },
  { id: 36, key: 'dhr', value: 'ðr', label: 'ðr' },
  { id: 37, key: 'fj', value: 'fj', label: 'fj' },
  { id: 38, key: 'fr', value: 'fr', label: 'fr' },
  { id: 39, key: 'fv', value: 'fv', label: 'fv' },
  { id: 40, key: 'fw', value: 'fw', label: 'fw' },
  { id: 41, key: 'gd', value: 'gd', label: 'gd' },
  { id: 42, key: 'gdh', value: 'gð', label: 'gð' },
  { id: 43, key: 'gn', value: 'gn', label: 'gn' },
  { id: 44, key: 'gr', value: 'gr', label: 'gr' },
  { id: 45, key: 'gv', value: 'gv', label: 'gv' },
  { id: 46, key: 'gw', value: 'gw', label: 'gw' },
  { id: 47, key: 'gz', value: 'gz', label: 'gz' },
  { id: 48, key: 'gzh', value: 'gʒ', label: 'gʒ' },
  { id: 49, key: 'hw', value: 'hw', label: 'hw' },
  { id: 50, key: 'gjv', value: 'ɟv', label: 'ɟv' },
  { id: 51, key: 'kd', value: 'kd', label: 'kd' },
  { id: 52, key: 'kf', value: 'kf', label: 'kf' },
  { id: 53, key: 'km', value: 'km', label: 'km' },
  { id: 54, key: 'kn', value: 'kn', label: 'kn' },
  { id: 55, key: 'kɲ', value: 'kɲ', label: 'kɲ' },
  { id: 56, key: 'kr', value: 'kr', label: 'kr' },
  { id: 57, key: 'ks', value: 'ks', label: 'ks' },
  { id: 58, key: 'ksh', value: 'kʃ', label: 'kʃ' },
  { id: 59, key: 'kt', value: 'kt', label: 'kt' },
  { id: 60, key: 'kts', value: 'kt͡s', label: 'kt͡s' },
  { id: 61, key: 'ktsh', value: 'kt͡ʃ', label: 'kt͡ʃ' },
  { id: 62, key: 'kv', value: 'kv', label: 'kv' },
  { id: 63, key: 'kw', value: 'kw', label: 'kw' },
  { id: 64, key: 'mj', value: 'mj', label: 'mj' },
  { id: 65, key: 'pf', value: 'pf', label: 'pf' },
  { id: 66, key: 'pj', value: 'pj', label: 'pj' },
  { id: 67, key: 'pn', value: 'pn', label: 'pn' },
  { id: 68, key: 'pɲ', value: 'pɲ', label: 'pɲ' },
  { id: 69, key: 'pr', value: 'pr', label: 'pr' },
  { id: 70, key: 'ps', value: 'ps', label: 'ps' },
  { id: 71, key: 'psh', value: 'pʃ', label: 'pʃ' },
  { id: 72, key: 'pt', value: 'pt', label: 'pt' },
  { id: 73, key: 'pw', value: 'pw', label: 'pw' },
  { id: 74, key: 'rj', value: 'rj', label: 'rj' },
  { id: 75, key: 'sb', value: 'sb', label: 'sb' },
  { id: 76, key: 'sc', value: 'sc', label: 'sc' },
  { id: 77, key: 'sf', value: 'sf', label: 'sf' },
  { id: 78, key: 'sk', value: 'sk', label: 'sk' },
  { id: 79, key: 'sm', value: 'sm', label: 'sm' },
  { id: 80, key: 'sn', value: 'sn', label: 'sn' },
  { id: 81, key: 'snj', value: 'sɲ', label: 'sɲ' },
  { id: 82, key: 'sp', value: 'sp', label: 'sp' },
  { id: 83, key: 'sr', value: 'sr', label: 'sr' },
  { id: 84, key: 'st', value: 'st', label: 'st' },
  { id: 85, key: 'sv', value: 'sv', label: 'sv' },
  { id: 86, key: 'sw', value: 'sw', label: 'sw' },
  { id: 87, key: 'shc', value: 'ʃc', label: 'ʃc' },
  { id: 88, key: 'shf', value: 'ʃf', label: 'ʃf' },
  { id: 89, key: 'shk', value: 'ʃk', label: 'ʃk' },
  { id: 90, key: 'shm', value: 'ʃm', label: 'ʃm' },
  { id: 91, key: 'shn', value: 'ʃn', label: 'ʃn' },
  { id: 92, key: 'shnj', value: 'ʃɲ', label: 'ʃɲ' },
  { id: 93, key: 'shr', value: 'ʃr', label: 'ʃr' },
  { id: 94, key: 'sht', value: 'ʃt', label: 'ʃt' },
  { id: 95, key: 'shv', value: 'ʃv', label: 'ʃv' },
  { id: 96, key: 'shw', value: 'ʃw', label: 'ʃw' },
  { id: 97, key: 'tj', value: 'tj', label: 'tj' },
  { id: 98, key: 'tr', value: 'tr', label: 'tr' },
  { id: 99, key: 'tw', value: 'tw', label: 'tw' },
  { id: 100, key: 'tsr', value: 't͡sr', label: 't͡sr' },
  { id: 101, key: 'tsv', value: 't͡sv', label: 't͡sv' },
  { id: 102, key: 'tshn', value: 't͡ʃn', label: 't͡ʃn' },
  { id: 103, key: 'tshr', value: 't͡ʃr', label: 't͡ʃr' },
  { id: 104, key: 'tshv', value: 't͡ʃv', label: 't͡ʃv' },
  { id: 105, key: 'tshw', value: 't͡ʃw', label: 't͡ʃw' },
  { id: 106, key: 'vj', value: 'vj', label: 'vj' },
  { id: 107, key: 'vr', value: 'vr', label: 'vr' },
  { id: 108, key: 'zm', value: 'zm', label: 'zm' },
  { id: 109, key: 'zr', value: 'zr', label: 'zr' },
  { id: 110, key: 'zv', value: 'zv', label: 'zv' },
  { id: 111, key: 'zw', value: 'zw', label: 'zw' },
  { id: 112, key: 'zhf', value: 'ʒf', label: 'ʒf' },
  { id: 113, key: 'zhk', value: 'ʒk', label: 'ʒk' },
  { id: 114, key: 'zhm', value: 'ʒm', label: 'ʒm' },
  { id: 115, key: 'zhn', value: 'ʒn', label: 'ʒn' },
  { id: 116, key: 'zhr', value: 'ʒr', label: 'ʒr' },
  { id: 117, key: 'zhs', value: 'ʒs', label: 'ʒs' },
  { id: 118, key: 'zhv', value: 'ʒv', label: 'ʒv' },
  { id: 119, key: 'thr', value: 'θr', label: 'θr' },
  { id: 120, key: 'brj', value: 'brj', label: 'brj' },
  { id: 121, key: 'drj', value: 'drj', label: 'drj' },
  { id: 122, key: 'dvj', value: 'dvj', label: 'dvj' },
  { id: 123, key: 'dhrj', value: 'ðrj', label: 'ðrj' },
  { id: 124, key: 'frj', value: 'frj', label: 'frj' },
  { id: 125, key: 'fvj', value: 'fvj', label: 'fvj' },
  { id: 126, key: 'gbr', value: 'gbr', label: 'gbr' },
  { id: 127, key: 'gdr', value: 'gdr', label: 'gdr' },
  { id: 128, key: 'gdhr', value: 'gðr', label: 'gðr' },
  { id: 129, key: 'grb', value: 'grb', label: 'grb' },
  { id: 130, key: 'grd', value: 'grd', label: 'grd' },
  { id: 131, key: 'grdh', value: 'grð', label: 'grð' },
  { id: 132, key: 'grj', value: 'grj', label: 'grj' },
  { id: 133, key: 'grv', value: 'grv', label: 'grv' },
  { id: 134, key: 'grz', value: 'grz', label: 'grz' },
  { id: 135, key: 'gvj', value: 'gvj', label: 'gvj' },
  { id: 136, key: 'gvr', value: 'gvr', label: 'gvr' },
  { id: 137, key: 'gzr', value: 'gzr', label: 'gzr' },
  { id: 138, key: 'kdj', value: 'kdj', label: 'kdj' },
  { id: 139, key: 'kdr', value: 'kdr', label: 'kdr' },
  { id: 140, key: 'kfj', value: 'kfj', label: 'kfj' },
  { id: 141, key: 'kmj', value: 'kmj', label: 'kmj' },
  { id: 142, key: 'krd', value: 'krd', label: 'krd' },
  { id: 143, key: 'krj', value: 'krj', label: 'krj' },
  { id: 144, key: 'krs', value: 'krs', label: 'krs' },
  { id: 145, key: 'krdh', value: 'krʃ', label: 'krʃ' },
  { id: 146, key: 'krt', value: 'krt', label: 'krt' },
  { id: 147, key: 'krts', value: 'krt͡s', label: 'krt͡s' },
  { id: 148, key: 'krtsh', value: 'krt͡ʃ', label: 'krt͡ʃ' },
  { id: 149, key: 'krzh', value: 'krʒ', label: 'krʒ' },
  { id: 150, key: 'ksr', value: 'ksr', label: 'ksr' },
  { id: 151, key: 'kshr', value: 'kʃr', label: 'kʃr' },
  { id: 152, key: 'ktj', value: 'ktj', label: 'ktj' },
  { id: 153, key: 'ktr', value: 'ktr', label: 'ktr' },
  { id: 154, key: 'ktshr', value: 'kt͡ʃr', label: 'kt͡ʃr' },
  { id: 155, key: 'kvj', value: 'kvj', label: 'kvj' },
  { id: 156, key: 'sbj', value: 'sbj', label: 'sbj' },
  { id: 157, key: 'sfj', value: 'sfj', label: 'sfj' },
  { id: 158, key: 'skr', value: 'skr', label: 'skr' },
  { id: 159, key: 'smj', value: 'smj', label: 'smj' },
  { id: 160, key: 'spj', value: 'spj', label: 'spj' },
  { id: 161, key: 'spr', value: 'spr', label: 'spr' },
  { id: 162, key: 'srj', value: 'srj', label: 'srj' },
  { id: 163, key: 'stj', value: 'stj', label: 'stj' },
  { id: 164, key: 'str', value: 'str', label: 'str' },
  { id: 165, key: 'svj', value: 'svj', label: 'svj' },
  { id: 166, key: 'shkr', value: 'ʃkr', label: 'ʃkr' },
  { id: 167, key: 'shpr', value: 'ʃpr', label: 'ʃpr' },
  { id: 168, key: 'shtr', value: 'ʃtr', label: 'ʃtr' },
  { id: 169, key: 'trj', value: 'trj', label: 'trj' },
  { id: 170, key: 'tsrj', value: 't͡srj', label: 't͡srj' },
  { id: 171, key: 'tsvj', value: 't͡svj', label: 't͡svj' },
  { id: 172, key: 'vrj', value: 'vrj', label: 'vrj' },
  { id: 173, key: 'zmj', value: 'zmj', label: 'zmj' },
  { id: 174, key: 'zrj', value: 'zrj', label: 'zrj' },
  { id: 175, key: 'zvj', value: 'zvj', label: 'zvj' },
  { id: 176, key: 'thrj', value: 'θrj', label: 'θrj' },
  { id: 177, key: 'gbrj', value: 'gbrj', label: 'gbrj' },
  { id: 178, key: 'gdrj', value: 'gdrj', label: 'gdrj' },
  { id: 179, key: 'gdhrj', value: 'gðrj', label: 'gðrj' },
  { id: 180, key: 'gvrj', value: 'gvrj', label: 'gvrj' },
  { id: 181, key: 'gzrj', value: 'gzrj', label: 'gzrj' },
  { id: 182, key: 'kdrj', value: 'kdrj', label: 'kdrj' },
  { id: 183, key: 'kskr', value: 'kskr', label: 'kskr' },
  { id: 184, key: 'ksrj', value: 'ksrj', label: 'ksrj' },
  { id: 185, key: 'kstr', value: 'kstr', label: 'kstr' },
  { id: 186, key: 'ktrf', value: 'ktrf', label: 'ktrf' },
  { id: 187, key: 'ktrj', value: 'ktrj', label: 'ktrj' },
  { id: 188, key: 'ktrm', value: 'ktrm', label: 'ktrm' },
  { id: 189, key: 'ktrn', value: 'ktrn', label: 'ktrn' },
  { id: 190, key: 'ktrnj', value: 'ktrɲ', label: 'ktrɲ' },
  { id: 191, key: 'ktrs', value: 'ktrs', label: 'ktrs' },
  { id: 192, key: 'ktrsh', value: 'ktrʃ', label: 'ktrʃ' },
  { id: 193, key: 'ktrtsh', value: 'ktrt͡ʃ', label: 'ktrt͡ʃ' },
  { id: 194, key: 'ktshrf', value: 'kt͡ʃrf', label: 'kt͡ʃrf' },
  { id: 195, key: 'ktshrm', value: 'kt͡ʃrm', label: 'kt͡ʃrm' },
  { id: 196, key: 'ktshrs', value: 'kt͡ʃrs', label: 'kt͡ʃrs' },
  { id: 197, key: 'ktshrʃ', value: 'kt͡ʃrʃ', label: 'kt͡ʃrʃ' },
  { id: 198, key: 'skrj', value: 'skrj', label: 'skrj' },
  { id: 199, key: 'sprj', value: 'sprj', label: 'sprj' },
  { id: 200, key: 'strj', value: 'strj', label: 'strj' },
]
